import React from "react";
import { Users } from "lucide-react";
import SettingsListPanel from "./SettingsListPanel";

const EmployeeTypesManagement = () => (
  <SettingsListPanel
    config={{
      title: "Employee Types",
      subtitle: "Manage employee types",
      icon: Users,
      endpoint: "/api/settings/employment-types",
      itemLabel: "Employee Type",
      columnLabel: "Name",
      placeholder: "Enter employee type name",
    }}
  />
);

export default EmployeeTypesManagement;
